import { ReactNode } from 'react';

import { Box } from '../../Box/Box';
import { Text } from '../../Text/Text';
import { StylesOptions } from '../../hooks/useStyles';

/**
 * @beta
 */
export function ListboxEmptyMessage({
  children,
  styles,
}: {
  children?: ReactNode;
} & StylesOptions) {
  return (
    <Box px="sp-16" py="sp-8" styles={styles}>
      <Text color="gray-60">{children || 'Нет вариантов'}</Text>
    </Box>
  );
}
